import React from 'react';

export default function TechnicianSelect({ technicians = [], readStatus = 'available', message = '', value = '', onChange, disabled = false, ...props }) {
    const available = readStatus === 'available';
    const missingAssigned = Boolean(value) && !technicians.some((row) => String(row.id) === String(value));
    const noticeId = `${props['data-testid'] || 'technician-select'}-notice`;
    const notice = message || (readStatus === 'loading' ? 'جارٍ تحميل قائمة الفنيين…' : 'قائمة الفنيين غير متاحة. لم يتغير الفني المسجل.');
    return <>
        <select {...props} value={value} onChange={onChange} disabled={disabled || !available} aria-describedby={!available ? noticeId : undefined}>
            <option value="">{available ? '— غير محدد —' : readStatus === 'loading' ? 'جارٍ تحميل الفنيين…' : 'قائمة الفنيين غير متاحة'}</option>
            {missingAssigned && <option value={value}>الفني المسجل — بياناته غير متاحة في القائمة</option>}
            {available && technicians.map((row) => <option key={row.id} value={row.id}>{row.name}</option>)}
        </select>
        {!available && <p id={noticeId} role="status" className="text-xs mt-2" style={{ color: '#475569' }}>{notice}</p>}
    </>;
}
